import { Route, Routes, Navigate } from "react-router-dom";

import Tokens from "./pages/tokens";

const App = () => {
  return (
    <Routes>
      <Route path="/tokens/shuffle" element={<Tokens />}></Route>
      <Route path="/tokens/trice" element={<Tokens />}></Route>
      <Route
        path="*"
        element={<Navigate to="/tokens/shuffle" replace />}
      ></Route>
    </Routes>
  );
};

export default App;
